module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.filteredData), function(usuario) {
    return _c('a', {
      attrs: {
        "href": "#openChat"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openChat(usuario)
        }
      }
    }, [_c('chat-usuario-item', {
      attrs: {
        "usuario": usuario,
        "currentUser": _vm.currentUser
      }
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c3760d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/chat/components/ChatUsuarios.vue
// module id = 1933
// module chunks = 18